module.exports = __webpack_public_path__ + "static/media/08-mobile-errors.d3dcee31.png";